import { useEffect, useState } from 'react';
import { useReduxState } from 'hooks';
import { breakpoints } from 'styles';
import {
  Box,
  BoxTable,
  BoxTableCell,
  BoxTableHeader,
  BoxTableRow
} from 'components/common/box';
import {
  Modal,
  ModalContent,
  ModalFooter,
  ModalPortal
} from 'components/common/modal';
import { Alert, ApiDownloadButton } from 'components/common';

interface Props {
  onModalDismiss?: () => Promise<void> | void;
  passwords: { [username: string]: string };
}

const UserPasswordReview = ({ onModalDismiss, passwords }: Props) => {
  const { messages } = useReduxState();

  const [userPasswords, setUserPasswords] = useState<typeof passwords>({});

  useEffect(() => {
    if (Object.keys(passwords).length) setUserPasswords({ ...passwords });
  }, [passwords]);

  const handleHide = () => {
    setUserPasswords({});
    if (onModalDismiss) onModalDismiss();
  };

  const visible = Boolean(Object.keys(userPasswords).length);

  return (
    <ModalPortal>
      <Modal
        closeButton={true}
        onHide={handleHide}
        title={messages.authSetPasswordSuccess}
        visible={visible}
        width="medium"
      >
        <ModalContent>
          <Alert
            style={{ marginBottom: 15 }}
            text={messages.userPasswordAlert}
            type="warning-light"
          />

          <Box padding={0} title={messages.summaryAddedUsers}>
            <BoxTable>
              <BoxTableHeader hideAtBreakpoint={breakpoints.medium}>
                <BoxTableCell>{messages.commonUsername}</BoxTableCell>
                <BoxTableCell>{messages.commonPassword}</BoxTableCell>
              </BoxTableHeader>

              {Object.entries(userPasswords).map((data) => (
                <BoxTableRow key={data[0]}>
                  <BoxTableCell>{data[0]}</BoxTableCell>
                  <BoxTableCell>{data[1]}</BoxTableCell>
                </BoxTableRow>
              ))}
            </BoxTable>
          </Box>
        </ModalContent>

        <ModalFooter>
          <ApiDownloadButton
            category="success"
            icon="file-excel"
            filename="user_passwords.xlsx"
            packet={userPasswords}
            text={messages.commonExportData}
            url="/admin/export-passwords"
          />
        </ModalFooter>
      </Modal>
    </ModalPortal>
  );
};

export default UserPasswordReview;
